import React from 'react';
import { Helmet } from 'react-helmet';
// Constants
import { CompanyName, HomePageDescription } from '../../utils/Constants';
// Components
import Navbar from '../../components/nav/Navbar';
import FooterComponent from '../../components/footer/FooterComponent';
import HomePageMainContainer from '../../components/home/HomePageMainContainer';
import HomePageHeader from '../../components/home/HomePageHeader';

const HomePage = React.memo(() => {
  return (
    <>
      {/* Tab Data */}
      <Helmet>
        <title>{`${CompanyName} | Domination, BDSM & Fetish Experiences`}</title>
        <meta name='description' content={HomePageDescription} />
      </Helmet>

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <HomePageHeader />

          {/* Main page content */}
          <HomePageMainContainer />

          {/* Footer */}
          <FooterComponent />
        </div>
      </div>
    </>
  );
});

export default HomePage;
